import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Url } from "../url";

// Get initial state from localStorage if available

const initialState = {
  checkOut: [],
  loading: false,
  error: null,
};

export const fetchCheckOut = createAsyncThunk(
  "checkOut/fetchCheckOut",
  async (payload) => {
    const response = await fetch(`${Url}/be/getBookingForm`, {
      method: "POST",
      headers: {
        accept: "text/plain",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error("Failed to fetch extras");
    }
    return await response.json();
  }
);

const checkOutSlice = createSlice({
  name: "checkOut",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCheckOut.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCheckOut.fulfilled, (state, action) => {
        state.loading = false;
        state.checkOut = action.payload;
      })
      .addCase(fetchCheckOut.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default checkOutSlice.reducer;
